module.exports = __webpack_public_path__ + "static/media/approve-request-modal-pic.0fcd66b5.svg";